import axiosConfig from "./axiosConfig";

export interface ApolloQuotaResponse {
  configured: boolean;
  dayLimit?: number;
  dayConsumed?: number;
  dayLeft?: number;
  hourLeft?: number;
  minuteLeft?: number;
  error?: string;
}

// Live Apollo free-tier daily discovery quota (calls used vs limit) for the
// Leads-costs card. configured:false when no key is set on the environment.
// The BE returns a shaped 502 {configured:true, error} on an Apollo outage, so
// accept it (validateStatus) rather than throwing - otherwise the card would
// mis-render an outage as "not configured".
const getApolloQuota = async (
  authToken: string
): Promise<ApolloQuotaResponse> => {
  const { data } = await axiosConfig.get(`/leads/apollo-quota`, {
    headers: { Authorization: `Bearer ${authToken}` },
    validateStatus: (status) => status === 200 || status === 502,
  });
  return data;
};

export default getApolloQuota;
